import { Button } from 'antd';
import PropTypes from 'prop-types';
import React from 'react';
import { useTranslation } from 'react-i18next';
import MiniTable from '../../../components/mini-table';
import { compareBooleans } from '../../../util/boolean';
import { formatCep } from '../../../util/cep';
import { formatCnpj } from '../../../util/cnpj';
import { compareStrings } from '../../../util/string';
import TableCellEllipsis from "../../../components/table-cell-ellipsis";

export default function EmpresaUnidadesTable({
  dataSource,
  loading,
  miniTableRef,
  onClick,
  onSelectedIdsChange,
  selectedIds,
  title
}) {
  const { t } = useTranslation();

  const fireClick = empresa =>
    typeof onClick === 'function' ? onClick(empresa) : undefined;

  const cellStyle = { minWidth: 100 };

  const columns = [
    {
      title: t('Unidade'),
      dataIndex: 'apelido',
      key: 'apelido',
      sorter: (a, b) => compareStrings(a.apelido, b.apelido),
      render: (text, record) => (
        <div style={cellStyle}>
          <Button type="link" onClick={() => fireClick(record)}>
            {text}
          </Button>
        </div>
      ),
    },
    {
      title: t('CNPJ'),
      dataIndex: 'cnpj',
      key: 'cnpj',
      width: 150,
      sorter: (a, b) => compareStrings(a.cnpj, b.cnpj),
      render: (text) => (
        <div style={cellStyle}>{formatCnpj(text)}</div>
      ),
    },
    {
      title: t('Endereço'),
      dataIndex: 'endereco',
      key: 'endereco',
      sorter: (a, b) => compareStrings(a.endereco, b.endereco),
      render: (text, record) => {
        const cidadeEstado = [record.cidade, record.estado].filter(Boolean).join('/');
        const cep = record.cep ? t('CEP') + ': ' + formatCep(record.cep) : null;
        const endereco = [record.endereco, cidadeEstado, cep].filter(Boolean).join(', ');
        return (
          <div style={{ minWidth: 180 }}>
            <TableCellEllipsis text={endereco} />
          </div>
        );
      },
    },
    {
      title: t('Objeto Social'),
      dataIndex: 'objetoSocial',
      key: 'objetoSocial',
      sorter: (a, b) => compareStrings(a.objetoSocial, b.objetoSocial),
      render: (text) => (
        <div style={{ minWidth: 150 }}>
          <TableCellEllipsis text={text} />
        </div>
      ),
    },
    {
      title: t('Observação'),
      dataIndex: 'obs',
      key: 'obs',
      sorter: (a, b) => compareStrings(a.obs, b.obs),
      render: (text) => (
        <div style={{ minWidth: 150 }}>
          <TableCellEllipsis text={text} />
        </div>
      ),
    },
    {
      title: t('Ativa'),
      dataIndex: 'ativa',
      key: 'ativa',
      width: 80,
      sorter: (a, b) => compareBooleans(a.ativa, b.ativa),
      render: (text, record) => (
        <div style={{ minWidth: 60 }}>
          {record.ativa ? t('Sim') : t('Não')}
        </div>
      ),
    },
  ];

  return (
    <MiniTable
      ref={miniTableRef}
      columns={columns}
      dataSource={dataSource}
      loading={loading}
      title={title}
      rowClassName={record => record.ativa ? undefined : 'inactive'}
      rowSelection={{
        selectedRowKeys: selectedIds,
        onChange: onSelectedIdsChange,
      }}
      scroll={{ y: 'auto' }}
    />
  );
}

EmpresaUnidadesTable.propTypes = {
  dataSource: PropTypes.array,
  loading: PropTypes.bool,
  miniTableRef: PropTypes.object,
  onClick: PropTypes.func,
  onSelectedIdsChange: PropTypes.func,
  selectedIds: PropTypes.arrayOf(PropTypes.number),
  title: PropTypes.func,
};
